import { useEffect, useState } from "react";
import { Loader, ShieldCheck } from "lucide-react";


export default function SubscriptionFeedback() {
  const [status, setStatus] = useState("processing"); // processing | success

  useEffect(() => {
    // Get the full URL after "?url=" (don't use URLSearchParams as it breaks on & characters)
    const fullSearch = window.location.search;
    const urlPrefix = "?url=";
    
    if (fullSearch.startsWith(urlPrefix)) {
      // Extract everything after "?url=" - this keeps the full URL intact
      const targetUrl = fullSearch.substring(urlPrefix.length);
      
      // Create a hidden iframe to hit the URL
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = targetUrl;
      document.body.appendChild(iframe);
      
      // After 2 seconds, remove iframe and show success
      setTimeout(() => {
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        setStatus("success");
      }, 2000);
    } else {
      // No URL param, show success directly
      setStatus("success");
    }
  }, []);

  // Show processing message
  if (status === "processing") {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white w-[400px] rounded-2xl shadow-xl p-8 md:p-12 max-w-md text-center">
          <div className="flex justify-center mb-6">
            <Loader className="w-20 h-20 text-gray-400 animate-spin" />
          </div>
          <h1 className="text-xl font-semibold text-gray-700">
            Processing your request...
          </h1>
        </div>
      </div>
    );
  }

  // Show success message
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white w-[400px] rounded-2xl shadow-xl p-8 md:p-12 max-w-md text-center">
        <div className="flex justify-center mb-6">
          <ShieldCheck className="w-20 h-20 text-purple-500 animate-pulse" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
          Processed!
        </h1>
        <p className="text-gray-600 text-lg mb-6">
          Your choice has been successfully taken care of.
        </p>
        <p className="text-gray-500 text-sm">
          You can close this window now.
        </p>
      </div>
    </div>
  );
}
